/**
 * We need this file to be separate from feature-flags.tsx because somehow it effects
 * the way that the code is parsed and converted to AST and used by src/packages/issue/test-util/src/utils.tsx.
 */
// eslint-disable-next-line jira/tangerine-no-export-star
export * from './feature-flags';
